import { showToast } from 'helpers/toast';

export function showNotification(type, message) {
  return () => {
    showToast[type](message);
  };
}
